import { BaseOption } from 'ui/selects';
import { Mapping } from 'api/MappingsAPI';

export const getOptionsFromMappings = (userMappings: Mapping[]): BaseOption<string>[] => {
  return userMappings.map(({ fieldName }) => ({
    id: fieldName,
    label: fieldName,
    value: fieldName,
  }));
};
